import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneoutstaiontaxihire() {



const cardData =
{
  keyword: 'Pune Outstation Taxi Hire',
  heading: 'Lotus Cab: Pune Outstation Taxi Hire',
  headingDescription: 'Lotus Cab offers reliable and affordable Pune Outstation Taxi Hire services designed for smooth long-distance travel. Whether you are planning a business trip, weekend getaway, pilgrimage, or family vacation, our well-maintained sedan and SUV fleet ensures maximum comfort and safety. Every ride is handled by a professional, background-verified chauffeur with excellent highway driving experience and route knowledge. We provide transparent per-km pricing, flexible one-way and round-trip options, and 24×7 customer support. With on-time pickup across Pune and hassle-free booking, Lotus Cab makes your outstation travel convenient, safe, and stress-free.',

  top: 'Top Outstation Destinations from Pune with Lotus Cab',

  "topPlaces": [
    {
      "title": "Mumbai",
      "description": "Mumbai is one of the most popular outstation routes from Pune. From Marine Drive and Gateway of India to major business hubs like BKC and Andheri, the city blends culture and commerce. The Mumbai-Pune Expressway ensures a fast and scenic journey. Lotus Cab provides safe, comfortable, and punctual Pune to Mumbai taxi hire."
    },
    {
      "title": "Nashik",
      "description": "Nashik is famous for Trimbakeshwar Temple and Sula Vineyards. It attracts pilgrims and wine lovers alike. The highway route from Pune is smooth and ideal for weekend travel. Lotus Cab ensures a relaxed and affordable Pune to Nashik taxi hire experience."
    },
    {
      "title": "Mahabaleshwar",
      "description": "Mahabaleshwar is a refreshing hill station with beautiful viewpoints and strawberry farms. Families frequently book Pune to Mahabaleshwar taxi hire for weekend escapes. Lotus Cab provides safe ghat driving and comfortable vehicles."
    },
    {
      "title": "Shirdi",
      "description": "Shirdi is a major pilgrimage destination dedicated to Sai Baba. Many travelers prefer Pune to Shirdi cab hire for darshan visits. Lotus Cab ensures timely arrival and peaceful outstation travel."
    },
    {
      "title": "Lonavala",
      "description": "Lonavala is a short-distance outstation getaway famous for waterfalls and scenic ghats. Pune to Lonavala outstation cab service is ideal for quick family trips. Lotus Cab offers flexible round-trip and one-way packages."
    },
    {
      "title": "Bangalore",
      "description": "Bangalore is a major IT hub and interstate travel destination. Pune to Bangalore taxi hire is preferred for corporate and relocation travel. Lotus Cab ensures safe long-distance highway journeys."
    },
    {
      "title": "Indore",
      "description": "Indore is a growing commercial city known for Rajwada Palace and Sarafa Bazaar. Pune to Indore cab hire is popular for business and family visits. Lotus Cab provides comfortable interstate taxi service."
    }
  ],

  "services": [
    { "name": "Pune Outstation Taxi Hire", "description": "Book Pune Outstation Taxi Hire with Lotus Cab for safe and affordable long-distance travel. We provide sedan and SUV options with transparent per km pricing and professional drivers for smooth interstate journeys." },
    { "name": "Outstation Taxi Service Pune", "description": "Reliable Outstation Taxi Service Pune with one-way and round-trip packages. Enjoy clean vehicles, experienced drivers, and 24/7 support for stress-free travel." },
    { "name": "Pune Outstation Cab Booking", "description": "Easy Pune Outstation Cab Booking with instant confirmation and transparent fare breakdown. Flexible pickup timing available across Pune." },
    { "name": "Pune One Way Outstation Taxi", "description": "Affordable Pune One Way Outstation Taxi where you pay only for one-side distance. Ideal for airport transfers and relocation travel." },
    { "name": "Pune Round Trip Outstation Cab", "description": "Flexible Pune Round Trip Outstation Cab service with customized return scheduling and competitive pricing." },
    { "name": "Pune to Mumbai Taxi Hire", "description": "Comfortable Pune to Mumbai Taxi Hire via expressway with experienced drivers and timely arrival guarantee." },
    { "name": "Pune to Nashik Taxi Hire", "description": "Safe and affordable Pune to Nashik Taxi Hire service with transparent per km billing and smooth highway driving." },
    { "name": "Pune to Mahabaleshwar Taxi Hire", "description": "Book Pune to Mahabaleshwar Taxi Hire for scenic hill station travel with professional ghat-experienced drivers." },
    { "name": "Pune to Shirdi Cab Hire", "description": "Reliable Pune to Shirdi Cab Hire ensuring timely darshan visits and comfortable spiritual travel." },
    { "name": "Pune to Lonavala Outstation Cab", "description": "Quick and affordable Pune to Lonavala Outstation Cab service for weekend family trips and short getaways." },
    { "name": "Pune to Bangalore Taxi Hire", "description": "Interstate Pune to Bangalore Taxi Hire service with experienced long-distance drivers and clean vehicles." },
    { "name": "Pune to Indore Cab Hire", "description": "Comfortable Pune to Indore Cab Hire with safe highway travel and competitive outstation pricing." },
    { "name": "Affordable Outstation Taxi Pune", "description": "Budget-friendly Affordable Outstation Taxi Pune service without compromising comfort and reliability." },
    { "name": "Luxury Outstation Cab Pune", "description": "Premium Luxury Outstation Cab Pune service with high-end vehicles for corporate and VIP travel." },
    { "name": "24/7 Outstation Cab Pune", "description": "Round-the-clock 24/7 Outstation Cab Pune service ensuring flexible booking and emergency travel support." },
    { "name": "Corporate Outstation Taxi Pune", "description": "Professional Corporate Outstation Taxi Pune service with billing support and punctual travel solutions." },
    { "name": "Family Trip Outstation Cab Pune", "description": "Spacious and safe Family Trip Outstation Cab Pune service ideal for group and holiday travel." },
    { "name": "Cheap Outstation Taxi Pune", "description": "Cheap Outstation Taxi Pune with competitive per km pricing and transparent billing structure." },
    { "name": "Best Outstation Cab Service Pune", "description": "Top-rated Best Outstation Cab Service Pune known for reliability, punctuality, and customer satisfaction." }
  ],

  "tableData": [
    ["Pune Outstation Taxi Hire", "Outstation Taxi Service Pune"],
    ["Pune Outstation Cab Booking", "Pune One Way Outstation Taxi"],
    ["Pune Round Trip Outstation Cab", "Pune to Mumbai Taxi Hire"],
    ["Pune to Nashik Taxi Hire", "Pune to Mahabaleshwar Taxi Hire"],
    ["Pune to Shirdi Cab Hire", "Pune to Lonavala Outstation Cab"],
    ["Pune to Bangalore Taxi Hire", "Pune to Indore Cab Hire"],
    ["Affordable Outstation Taxi Pune", "Luxury Outstation Cab Pune"],
    ["24/7 Outstation Cab Pune", "Corporate Outstation Taxi Pune"],
    ["Family Trip Outstation Cab Pune", "Cheap Outstation Taxi Pune"],
    ["Best Outstation Cab Service Pune", ""]
  ],

  "whychoose": [
    { "WhyChooseheading": "Reliable Outstation Taxi Hire", "WhyChoosedescription": "Trusted service provider for long-distance travel from Pune." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear per km rates with no hidden charges." },
    { "WhyChooseheading": "Experienced Highway Drivers", "WhyChoosedescription": "Professional chauffeurs skilled in interstate routes." },
    { "WhyChooseheading": "Flexible Travel Options", "WhyChoosedescription": "One-way and round-trip booking flexibility." },
    { "WhyChooseheading": "24/7 Customer Support", "WhyChoosedescription": "Round-the-clock booking and travel assistance." },
    { "WhyChooseheading": "Clean & Maintained Fleet", "WhyChoosedescription": "Well-serviced and sanitized vehicles." },
    { "WhyChooseheading": "Corporate Travel Solutions", "WhyChoosedescription": "Specialized corporate outstation packages." },
    { "WhyChooseheading": "On-Time Pickup Guarantee", "WhyChoosedescription": "Punctual departure and arrival assurance." }
  ]
}

const faqData = [
  { question: 'Does Lotus Cab provide Pune Outstation Taxi Hire?', answer: 'Yes, we offer reliable outstation taxi hire services from Pune.' },
  { question: 'Can I book one-way taxi from Pune?', answer: 'Yes, one-way outstation taxi booking is available.' },
  { question: 'Are fares calculated per km?', answer: 'Yes, outstation fares are calculated per km basis.' },
  { question: 'Do you provide round-trip packages?', answer: 'Yes, flexible round-trip packages are available.' },
  { question: 'Is booking available 24/7?', answer: 'Yes, our support team operates 24/7.' },
  { question: 'Are vehicles sanitized?', answer: 'Yes, all vehicles are cleaned before trips.' },
  { question: 'Do you provide luxury cars?', answer: 'Yes, premium sedan and SUV options are available.' },
  { question: 'Can I schedule early pickup?', answer: 'Yes, flexible pickup timing is available.' },
  { question: 'Do you offer corporate billing?', answer: 'Yes, we support corporate travel billing.' },
  { question: 'Is advance booking recommended?', answer: 'Yes, advance booking ensures vehicle availability.' }
];

const testimonials = [
  { id: 1, name: 'Mr. Kunal Patil', feedback: 'Very smooth Pune to Mumbai journey with Lotus Cab.', rating: 5 },
  { id: 2, name: 'Mrs. Anjali Mehta', feedback: 'Excellent outstation cab service and transparent fare.', rating: 5 }
];







































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Outstation Taxi Hire",
  "image": "https://lotuscab.com/assets/images/pune-outstation-taxi-hire.jpg", 
  "description": "Lotus Cab provides reliable Pune outstation taxi hire with one way and round trip cab booking options. Travel comfortably from Pune to Mumbai, Nashik, Mahabaleshwar, Shirdi, Lonavala, Bangalore, Indore and more with professional drivers and affordable pricing.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "11",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-outstation-taxi-hire"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pune Outstation Taxi Hire | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune outstation taxi hire with Lotus Cab. One way & round trip outstation cab service from Pune to Mumbai, Nashik, Mahabaleshwar, Shirdi & more. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune Outstation Taxi Hire, Outstation Taxi Service Pune, Pune Outstation Cab Booking, Pune One Way Outstation Taxi, Pune Round Trip Outstation Cab, Pune to Mumbai Taxi Hire, Pune to Nashik Taxi Hire, Pune to Mahabaleshwar Taxi Hire, Pune to Shirdi Cab Hire, Pune to Lonavala Outstation Cab, Pune to Bangalore Taxi Hire, Pune to Indore Cab Hire, Affordable Outstation Taxi Pune, Luxury Outstation Cab Pune, 24/7 Outstation Cab Pune, Corporate Outstation Taxi Pune, Family Trip Outstation Cab Pune, Cheap Outstation Taxi Pune, Best Outstation Cab Service Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/2.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneoutstaiontaxihire;